// extracted by mini-css-extract-plugin
export default {"container":"NH-z","header":"OH-z","details":"PH-z","link":"QH-z"};